import CloudIcon from '@mui/icons-material/Cloud'
import LockIcon from '@mui/icons-material/Lock'
import GppGoodIcon from '@mui/icons-material/GppGood'

function LandingSecurity () {
  return (
    <section className='lp-security-section'>
      <div className='lp-section-content'>
        <h2 className='lp-section-title'>Datenschutz & Sicherheit</h2>
        <p className='lp-section-subtitle'>
          Ihre Daten sind bei uns in sicheren Händen – Made in Europe
        </p>

        <div className='lp-security-grid'>
          <div className='lp-security-card'>
            <div className='lp-security-icon'>
              <CloudIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Azure Deutschland/Schweden</h3>
            <p>
              Unsere KI läuft ausschließlich auf Azure OpenAI in Schweden.
              Ihre Daten verlassen niemals die EU und sind zu 100%
              DSGVO-konform.
            </p>
          </div>

          <div className='lp-security-card'>
            <div className='lp-security-icon'>
              <LockIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>Keine Datenweitergabe</h3>
            <p>
              Ihre Daten gehören Ihnen. Wir trainieren keine externen
              KI-Modelle mit Ihren Informationen und geben nichts an Dritte
              weiter.
            </p>
          </div>

          <div className='lp-security-card'>
            <div className='lp-security-icon'>
              <GppGoodIcon sx={{ fontSize: 48 }} />
            </div>
            <h3>DSGVO-konform</h3>
            <p>
              Volle Kontrolle über Ihre Daten. Sie können jederzeit alle Daten
              einsehen, exportieren oder löschen lassen. Transparente
              Datenverarbeitung nach DSGVO-Richtlinien.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default LandingSecurity

